import Cookies from 'js-cookie';

function FAQController($scope, $rootScope, $route, $location, $routeParams, $translate) {
  "ngInject";

  $scope.FAQGroups = [];

  $scope.buildFAQGroupList = function (Page) {
    if (Page.charAt(0) == 'F') {
      $scope.FAQGroups = [];
      $translate(Page).then(function (result) {
        $scope.FAQGroups = JSON.parse(result);
      });
    } else {
      $scope.FAQGroups = JSON.parse(Page);
    }
  }
};

export default {
  name: 'FAQController',
  fn: FAQController
}